export default "__VITE_ASSET__db8342cd__"